import React from 'react'
import Provider from '@@/core/plugin-access/Provider'
import * as app from '@/app'
const { getAccess: _getAccess } = app || {}
const getAccess = (access, context) => {
    if( typeof _getAccess === 'function' ){
        return _getAccess(access, context)
    } else if( _getAccess && typeof _getAccess === 'object') {
        return Object.assign({}, access, _getAccess)
    }
    return access;
}
const accessStrictMode = false;

export function accessProvider(element, {routes}){
    const props = {
            routes,
            accessStrictMode,
            getAccess
        }
    return <Provider {...props}>{element}</Provider>
}
// generated at 2026/7/8 18:49:32 by sui v3.1.128